import Vue from 'vue'
import '@/directives/multi-event'
import { initCommon } from '@/shared/common'
import { t } from '@/shared/i18n'

const dateFormat = require('dateformat')

Vue.mixin({
  methods: {
    dateFormat, t
  }
})

// Global components
Vue.component('social-share', () => import(/* webpackChunkName: "social-share" */ '@/components/shared/social-share.vue'))
Vue.component('related-cards', () => import(/* webpackChunkName: "related-cards" */ '@/components/shared/related-cards.vue'))

const createApp = (options) => {
  if (options.mounted) {
    const oldMounted = options.mounted
    options.mounted = () => {
      oldMounted()
      initCommon()
    }
  } else {
    options.mounted = initCommon
  }
  return new Vue(options)
}


export {
  // eslint-disable-next-line import/prefer-default-export
  createApp
}
